export default function SiteFooter() {
  return (
    <footer style={{ background: '#f9f5ff' }} className="pt-14 pb-6">
      <div className="max-w-6xl mx-auto px-8">
        <div className="grid md:grid-cols-12 gap-10 pb-10 border-b border-gray-200">
          {/* Brand */}
          <div className="md:col-span-4">
            <div className="flex items-center mb-4">
              <img
                src="https://storage.readdy-site.link/project_files/3785ac0c-31ac-4f9e-b2ab-27ad3777db2a/7544398a-500f-41a6-81c3-aa7efbf1c0d2_logo-247.png?v=04135332188f9bc8b00780c66cd5837d"
                alt="247digitrend"
                className="h-36 w-auto object-contain"
              />
            </div>
            <div className="inline-flex items-center gap-1.5 bg-violet-50 border border-violet-100 rounded-full px-3 py-1 mb-3">
              <span className="w-1.5 h-1.5 rounded-full bg-violet-500 flex-shrink-0"></span>
              <span className="text-xs font-semibold text-violet-600 tracking-wide uppercase">
                Operated by 247 Digital Marketing Co., Ltd.
              </span>
            </div>
            <p className="text-sm text-gray-600 leading-relaxed mb-4">
              Your trusted guide in the digital landscape — we deliver{' '}
              <strong className="text-gray-800 font-semibold">100% unbiased reviews</strong>{' '}
              and in-depth comparisons of online tools and digital platforms.
            </p>
            <p className="text-sm text-gray-500 leading-relaxed">
              We help businesses cut through the noise, make smarter decisions, and grow efficiently
              in an ever-evolving digital world.
            </p>
            <div className="flex flex-col gap-2 mt-4">
              {[
                { icon: 'ri-shield-check-line', text: 'No sponsorship. No bias.' },
                { icon: 'ri-bar-chart-grouped-line', text: 'Real-world tested & verified' },
                { icon: 'ri-refresh-line', text: 'Always up-to-date' },
              ].map((item, i) => (
                <div key={i} className="flex items-center gap-2">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                    <i className={`${item.icon} text-violet-500 text-sm`}></i>
                  </div>
                  <span className="text-xs text-gray-500 font-medium">{item.text}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Resources */}
          <div className="md:col-span-2 md:col-start-6">
            <h5 className="text-sm font-bold text-gray-800 mb-4">Resources</h5>
            {[
              { label: 'All Reviews', href: '/reviews' },
              { label: 'Comparisons', href: '/comparisons' },
              { label: 'Categories', href: '/categories' },
              { label: 'Blog', href: '/blog' },
            ].map((item, i) => (
              <a
                key={i}
                href={item.href}
                className="block text-sm text-gray-500 hover:text-violet-600 transition-colors mb-3 cursor-pointer"
              >
                {item.label}
              </a>
            ))}
          </div>

          {/* Company */}
          <div className="md:col-span-2">
            <h5 className="text-sm font-bold text-gray-800 mb-4">Company</h5>
            {[
              { label: 'About Us', href: '/about' },
              { label: 'Contact', href: '/contact' },
              { label: 'Submit a Tool', href: '/submit-tool' },
              { label: 'Advertise', href: '/advertise' },
            ].map((item, i) => (
              <a
                key={i}
                href={item.href}
                className="block text-sm text-gray-500 hover:text-violet-600 transition-colors mb-3 cursor-pointer"
              >
                {item.label}
              </a>
            ))}
          </div>

          {/* Follow Us */}
          <div className="md:col-span-2">
            <h5 className="text-sm font-bold text-gray-800 mb-4">Follow Us</h5>
            <div className="flex items-center gap-3">
              {[
                { icon: 'ri-twitter-x-line', href: '#' },
                { icon: 'ri-linkedin-line', href: '#' },
                { icon: 'ri-facebook-line', href: '#' },
                { icon: 'ri-instagram-line', href: '#' },
              ].map((s, i) => (
                <a
                  key={i}
                  href={s.href}
                  className="w-9 h-9 flex items-center justify-center rounded-full border border-gray-200 bg-white text-gray-500 hover:text-violet-600 hover:border-violet-300 transition-all cursor-pointer"
                >
                  <i className={`${s.icon} text-base`}></i>
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="pt-5 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-xs text-gray-400">© 2026 247digitrend. All rights reserved.</p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-gray-400 hover:text-violet-600 transition-colors cursor-pointer">
              Privacy Policy
            </a>
            <a href="#" className="text-xs text-gray-400 hover:text-violet-600 transition-colors cursor-pointer">
              Terms of Service
            </a>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs text-gray-400 hover:text-violet-600 transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
